export default "__VITE_ASSET__dUQBeNPx__"